import {Injectable} from '@angular/core';
import {Router} from "@angular/router";
import {Location} from "@angular/common";

import {AuthenticationRoutesNames} from '@shared/constans/authentication-routes-names.constans';
import { TawkToChatService } from './tawk-to-chat.service';
import { Driver } from '@commons/models/domain/Driver';
import { ViewWorkers } from '@layout/driver/services/worker.service';

@Injectable({
  providedIn: 'root'
})
export class NewNavigationService {

  get isInAuthenticationModule(): boolean {
    return this.router.url.includes(AuthenticationRoutesNames.authenticationModuleName);
  }

  get isInDataSharingModule(): boolean {
    return this.router.url.includes('data-sharing');
  }

  get isShareLink(): boolean {
    return this.location.path().includes('/share/');
  }

  get isHandoverView(): boolean {
    return this.location.path().includes('/handover/');
  }

  get isPasswordResetConfirmView(): boolean {
    return this.location.path().includes('/password-reset-confirm');
  }

  get isPasswordResetView(): boolean {
    return this.location.path().includes('/reset-password');
  }

  constructor(
    private router: Router,
    private location: Location,
    private tawkToChatService: TawkToChatService,
  ) {
  }

  private toAuthentication(route: string) {
    this.router.navigate([AuthenticationRoutesNames.authenticationModuleName + route]);
  }

  toWelcome() {
    this.toAuthentication(AuthenticationRoutesNames.welcome);
  }

  toSelectDatabase() {
    this.toAuthentication(AuthenticationRoutesNames.selectDatabase);
  }

  toLogin() {
    this.toAuthentication(AuthenticationRoutesNames.login);
  }

  toCreateAccount() {
    this.toAuthentication(AuthenticationRoutesNames.createAccount);
  }

  toCreateAccountConfirmation() {
    this.toAuthentication(AuthenticationRoutesNames.createAccountConfirmation);
  }

  toResetPassword() {
    this.toAuthentication(AuthenticationRoutesNames.resetPassword);
  }

  toResetPasswordConfirmation(email: string) {
    this.toAuthentication(`${AuthenticationRoutesNames.resetPasswordConfirmation}/${email}`);
  }

  toSetNewPasswordConfirmation() {
    this.toAuthentication(AuthenticationRoutesNames.setNewPasswordConfirmation);
  }

  toMainPanel() {
    this.router.navigate(['/panel', 'main']);
    // this.router.navigate(['/panel', 'vehicle'], { queryParams: {mode: 'lite'}});//TODO GB można w przyszłości pokazywać odrazu panel pojazdów
  }

  toHandoverView(token: string) {
    this.router.navigate(['/handover-view', token]);
  }

  toMainPanelWithShareLink(shareLinkId: string) {
    this.router.navigate(['/panel', 'main'], { queryParams: { shareLinkId }});
  }

  toShare(shareId: string) {
    this.router.navigate([AuthenticationRoutesNames.share, shareId]);
  }

  toHandoverAuthView(shareId: string) {
    this.router.navigate([AuthenticationRoutesNames.handover, shareId]);
  }

  // toHandoverView(handoverId: string, returnId?: string) {
  //   const commands = ['/handover-view', `${handoverId}`];
  //   if (returnId)
  //     commands.push(`${returnId}`);

  //   this.router.navigate(commands);
  // }

  toVehiclesList() {
    this.router.navigate(['/panel', 'vehicle'], {queryParams: {mode: 'lite'}});
  }

  toEventsList() {
    this.router.navigate(['/panel', 'event'], {queryParams: {mode: 'lite'}});
  }

  toWorkersList() {
    this.router.navigate(['/panel', 'workers']);
    // this.router.navigate(['/panel', 'driver'], {queryParams: {mode: 'lite'}});
  }

  toCarParameterChartView() {
    this.router.navigate(['/panel', 'car-parameter-chart']);
  }

  toFilesDDDView() {
    this.router.navigate(['/panel', 'files-ddd']);
  }

  toTachographView() {
    this.router.navigate(['/panel', 'tachograph-charts']);
  }

  toTachographStatusView() {
    this.router.navigate(['/panel', 'tachograph']);
  }

  toTachographPermissionDeniedView() {
    this.router.navigate(['/panel', 'tachograph-permissions-denied']);
  }

  toReports() {
    this.router.navigate(['/panel', 'routes-report']);
  }

  toWorkerDetails(workerId: number) {
    this.router.navigate(['panel', 'driver'], {queryParams: {'mode': 'details', 'id': workerId}});
  }

  toDataSharing() {
    this.router.navigate(['/panel', 'data-sharing']);
  }

  toHelp() {
    this.router.navigate(['/panel', 'help']);
  }

  toProfile() {
    this.router.navigate(['/panel', 'profile']);
  }

  toLogout() {
    this.tawkToChatService.hideChat();
    this.toAuthentication(AuthenticationRoutesNames.logout);
  }

  toHandover() {
    this.router.navigate(['/panel', 'handover']);
  }

  public toVehicleFullList(): void {
    this.router.navigate(['/panel', 'vehicle-full-list']);
  }

  public toWorkerForm(workerData?: Driver): void {
    this.router.navigate(['/panel', 'worker-form', { workerData: workerData ? JSON.stringify(workerData) : null }]);
  }

}
